import { render, staticRenderFns } from "./Professor.vue?vue&type=template&id=110b41ca&scoped=true"
import script from "./Professor.vue?vue&type=script&lang=js"
export * from "./Professor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110b41ca",
  null
  
)

export default component.exports